import {GET_BundleKey} from '../constants/ActionTypes'

const INIT_STATE = {
    BundleKey: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_BundleKey:
            return {
                BundleKey: action.body,
                loading :false
            }
        default:
            return state;
    }
}